import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipperConsigneeByShortNameRequestParams {
  ShortName: string;
}

export const getPreClaimsShipperConsigneeByShortNameAPI = (params: GetShipperConsigneeByShortNameRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetShipperConsignee`,
    method: 'get',
    params: { ShortName: params.ShortName },
  });
};

export interface ShipperConsigneeByShortNameResponse {
  claimShipRecKey: number;
  customerKey: number;
  consigneeShipperName: string;
  addr1: string;
  addr2: string | null;
  city: string;
  state: string;
  zip: string;
  countryCode: string | null;
}

export const fetchShipperConsigneeByShortName = async (
  params: GetShipperConsigneeByShortNameRequestParams,
): Promise<ShipperConsigneeByShortNameResponse> => {
  const response: AxiosResponse<ShipperConsigneeByShortNameResponse> =
    await getPreClaimsShipperConsigneeByShortNameAPI(params);
  return response.data;
};
